<template>
  <div class="d-flex mt-2">
    <div class="side-frame-primary"></div>
    <div>
      <span style="font-size: 14px; color: #606266;line-height: 25px;">
        {{ $l('table_title_sku') || '产品明细列表' }}
      </span>
      <el-divider direction="vertical"></el-divider>
    </div>
    <b-col cols="5" style="padding-left: 0px;">
      <b-form @reset="reset" onsubmit="return false">
        <b-input-group size="sm">
          <b-form-input
            @keyup.enter="query"
            type="search"
            v-model.trim="form.keyword"
            :placeholder="$l('table_search') || '产品款号/NC编码/UPC  搜索……'"
          />
          <b-input-group-append>
            <b-button-group>
              <b-button-group slot="reference">
                <b-button variant="primary" size="sm" @click="query">
                  <i class="fa fa-search" />
                </b-button>
              </b-button-group>
            </b-button-group>
          </b-input-group-append>
          <b-button
            v-if="!disabled"
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="openAdjustShipmentQuantity()"
          >
            {{ $l('btn_text_adjust_quantity') || '调整出货数量' }}
          </b-button>
        </b-input-group>
      </b-form>
    </b-col>
    <EditQuantityForm
      :visible="adjustShipmentQuantityVisible"
      :hxShipmentJdCode="hxShipmentJdCode"
      v-if="adjustShipmentQuantityVisible"
      @close="close"
    />
  </div>
</template>

<script>
import EditQuantityForm from '../edit-quantity-form'
export default {
  props: {
    disabled: { type: Boolean, default: false },
    hxShipmentJdCode: { type: String, default: '' },
  },
  components: { EditQuantityForm },
  data() {
    return {
      adjustShipmentQuantityVisible: false,
      form: { keyword: '' },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    reset() {},
    openAdjustShipmentQuantity() {
      this.adjustShipmentQuantityVisible = true
    },
    close() {
      this.adjustShipmentQuantityVisible = false
      this.query()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-primary {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  line-height: 25px;
  margin-top: 3px;
}
</style>
